<template>
  <b-row>
    <b-col
      cols="12"
      class="text-right"
    >

      <b-button
        v-if="typeof(ReadOnly) === 'undefined'"
        class="col-2 ml-1"
        variant="outline-primary"
        @click="onEditBtnClicked"
      >แก้ไข</b-button>
      <b-button
        v-if="typeof(ReadOnly) === 'undefined' && IsDeleteAble === true && AllowDelete === true"
        class="col-2 ml-1"
        variant="danger"
        @click="onDeletedBtnClicked"
      >ลบ</b-button>
    </b-col>

    <b-col
      cols="12"
      md="6"
    >
      <b-form-group
        label="รหัสบัตรประชาชน: "
        label-cols-md="4"
      >
        <span
          class="row col-form-label"
          v-text="u.personalId"
        />
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group
        label="ชื่อ-นามสกุล ผู้ร้องทุกข์: "
        label-cols-md="4"
      >
        <span
          class="row col-form-label"
          v-text="u.fullname"
        />
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group
        label="ที่อยู่ปัจจุบันที่สามารถติดต่อได้: "
        label-cols-md="4"
      >
        <span
          class="row col-form-label"
          v-text="u.address"
        />
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group
        label="หมายเลขโทรศัพท์มือถือ: "
        label-cols-md="4"
      >
        <span
          class="row col-form-label"
          v-text="u.mobile"
        />
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group
        label="วัน เดือน ปีเกิด: "
        label-cols-md="4"
      >
        <span
          class="row col-form-label"
          v-text="u.birthDate"
        />
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group
        label="แฟกซ์: "
        label-cols-md="4"
      >
        <span
          class="row col-form-label"
          v-text="u.fax"
        />
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group
        label="อายุ: "
        label-cols-md="4"
      >
        <span
          class="row col-form-label"
          v-text="u.age"
        />
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group
        label="อีเมล: "
        label-cols-md="4"
      >
        <span
          class="row col-form-label "
          v-text="u.email"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BFormGroup, BRow, BCol, BFormInput, BListGroup, BListGroupItem, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BFormGroup,
    BRow,
    BCol,
    BFormInput,
    BListGroup,
    BListGroupItem,
  },
  props: {
    person: {
      type: Object,
      required: true,
    },
    IsReadOnly: 0,
    IsDeleteAble: false,
    AllowDelete : true,
  },
  setup(props) {
    return {
      u: props.person,
      ReadOnly: props.IsReadOnly,
    }
  },
  created() {
    // console.log('IsReadonly', this.props.IsReadonly)
  },
  methods: {
    onDeletedBtnClicked() {
      this.$emit('handle-deleted', this.u.id)
    },
    onEditBtnClicked() {
      console.log(this.u.id)
      this.$emit('handle-edit', this.u.id)
    },
  },
}
</script>

<style>

</style>
